import { transferBankPaymentMeta } from "src/data/DataMetatags";
import NextHead from "src/components/Seo/NextHead";
import Layout from "src/components/Layout";
import BreadcrumbComponent from "src/components/UserInterface/BreadcrumbComponent";
import { transferBankBreadcrumb } from "src/data/DataBreadcrumb";
import { defBreadcrumb } from "src/data/DataBreadcrumb";
import {
  TransferBankAccordion,
  TransferBankHeading,
  TransferBankWrapper,
} from "src/views/cara-pembayaran/transfer-bank";

const TransferBank = (props) => {
  const { breadcrumb, transferBankBreadcrumb, title, description, path } =
    props;

  return (
    <Layout>
      <NextHead
        title={title}
        description={description}
        url={path}
        breadcrumb={breadcrumb}
      />
      <BreadcrumbComponent items={transferBankBreadcrumb} />
      <TransferBankWrapper>
        <TransferBankHeading />
        <TransferBankAccordion />
      </TransferBankWrapper>
    </Layout>
  );
};

export const getStaticProps = () => {
  const { title, description, path } = transferBankPaymentMeta;

  const breadcrumb = [
    ...defBreadcrumb,
    {
      "@type": "ListItem",
      position: "2",
      item: {
        "@id": process.env.baseUrl + path,
        name: title,
      },
    },
  ];

  return {
    props: {
      breadcrumb,
      transferBankBreadcrumb,
      title,
      description,
      path,
    },
  };
};

export default TransferBank;
